module.exports = __webpack_public_path__ + "static/img/Tyler-Moriaty.14468c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tyler-Moriaty.jpg
// module id = pHnz
// module chunks = 0